import Vue from "vue";
import VueRouter from "vue-router";
import { Herramientas } from "../Auxiliares/Enums";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import SeccionPluviometros from "../views/Secciones/Pluviometros.vue";
import SeccionPluviometro from "../views/Secciones/Pluviometro.vue";
import SeccionFreatimetros from "../views/Secciones/Freatimetros.vue";
import SeccionFreatimetro from "../views/Secciones/Freatimetro.vue";
import SeccionVerMapa from "../views/Secciones/VerMapa.vue";
import Productores from "../views/Admin/Productores.vue";
import Establecimientos from "../views/Admin/Establecimientos.vue";
import SeccionVeris from "../views/Secciones/Veris.vue";
import SeccionVeri from "../views/Secciones/Veri.vue";
import SeccionAguas from "../views/Secciones/Aguas.vue";
import SeccionRegistrosAgua from "../views/Secciones/RegistrosAgua.vue";
import SeccionSuelos from "../views/Secciones/Suelos.vue";
import SeccionRegistrosSuelo from "../views/Secciones/RegistrosSuelo.vue";
import PerspectivasClimaticas from "../views/Secciones/PerspectivasClimaticas.vue";
import ManagerPdfTool from "../views/Secciones/ManagerPdfTool.vue";
import RegistrosManagerPdfTool from "../views/Secciones/Registros/RegistrosManagerPdfTool.vue";
Vue.use(VueRouter);

//TODO unificar rutas
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/index.html",
    name: "Home1",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: Herramientas.Pluviometros.path,
    name: Herramientas.Pluviometros.routeName,
    component: SeccionPluviometros,
  },
  {
    path: GetChildPath(Herramientas.Pluviometros.path),
    name: "Pluviometro",
    component: SeccionPluviometro,
  },
  {
    path: Herramientas.Veris.path,
    name: Herramientas.Veris.routeName,
    component: SeccionVeris,
  },
  {
    path: GetChildPath(Herramientas.Veris.path),
    name: "Veri",
    component: SeccionVeri,
  },
  {
    path: "/establecimientos/:Id?",
    name: "Establecimientos",
    component: Establecimientos,
  },
  {
    path: Herramientas.Freatimetros.path,
    name: Herramientas.Freatimetros.routeName,
    component: SeccionFreatimetros,
  },
  {
    path: GetChildPath(Herramientas.Freatimetros.path),
    name: "Freatimetro",
    component: SeccionFreatimetro,
  },
  {
    path: "/vermapa",
    name: "VerMapa",
    component: SeccionVerMapa,
  },
  {
    path: "/productores",
    name: "Productores",
    component: Productores,
  },
  {
    path: Herramientas.Aguas.path,
    name: Herramientas.Aguas.routeName,
    component: SeccionAguas,
  },
  {
    path: GetChildPath(Herramientas.Aguas.path),
    name: "RegistrosAgua",
    component: SeccionRegistrosAgua,
  },
  {
    path: Herramientas.Suelos.path,
    name: Herramientas.Suelos.routeName,
    component: SeccionSuelos,
  },
  {
    path: GetChildPath(Herramientas.Suelos.path),
    name: "RegistrosSuelo",
    component: SeccionRegistrosSuelo,
  },
  {
    path: Herramientas.PerspectivasClimaticas.path,
    name: Herramientas.PerspectivasClimaticas.routeName,
    component: PerspectivasClimaticas,
  },
  {
    path: Herramientas.Satelitales.path,
    name: Herramientas.Satelitales.routeName,
    component: ManagerPdfTool,
    props: { datos: Herramientas.Satelitales }
  },
  {
    path: GetChildPath(Herramientas.Satelitales.path),
    name: GetChildRouteName(Herramientas.Satelitales.routeName),
    component: RegistrosManagerPdfTool,
    props: { datos: Herramientas.Satelitales, childRouteName: GetChildRouteName(Herramientas.Satelitales.routeName) }
  },
  {
    path: Herramientas.MonitoreoDron.path,
    name: Herramientas.MonitoreoDron.routeName,
    component: ManagerPdfTool,
    props: { datos: Herramientas.MonitoreoDron }
  },
  {
    path: GetChildPath(Herramientas.MonitoreoDron.path),
    name: GetChildRouteName(Herramientas.MonitoreoDron.routeName),
    component: RegistrosManagerPdfTool,
    props: { datos: Herramientas.MonitoreoDron, childRouteName: GetChildRouteName(Herramientas.MonitoreoDron.routeName) }
  },
  {
    path: Herramientas.ServicioFertilizacion.path,
    name: Herramientas.ServicioFertilizacion.routeName,
    component: ManagerPdfTool,
    props: { datos: Herramientas.ServicioFertilizacion }
  },
  {
    path: GetChildPath(Herramientas.ServicioFertilizacion.path),
    name: GetChildRouteName(Herramientas.ServicioFertilizacion.routeName),
    component: RegistrosManagerPdfTool,
    props: { datos: Herramientas.ServicioFertilizacion, childRouteName: GetChildRouteName(Herramientas.ServicioFertilizacion.routeName) }
  },
  {
    path: Herramientas.AnalisisPostcosecha.path,
    name: Herramientas.AnalisisPostcosecha.routeName,
    component: ManagerPdfTool,
    props: { datos: Herramientas.AnalisisPostcosecha }
  },
  {
    path: GetChildPath(Herramientas.AnalisisPostcosecha.path),
    name: GetChildRouteName(Herramientas.AnalisisPostcosecha.routeName),
    component: RegistrosManagerPdfTool,
    props: { datos: Herramientas.AnalisisPostcosecha, childRouteName: GetChildRouteName(Herramientas.AnalisisPostcosecha.routeName) }
  },
];

function GetChildPath(parentPath) {
  return parentPath + "/:Id?";
}

function GetChildRouteName(parentRouteName) {
  return "Registros" + parentRouteName;
}
  
const router = new VueRouter({
  mode: "history",
  //mode : 'hash',
  base: process.env.BASE_URL,
  //base: "/AgroIdeas-MaizPlus/",
  routes,

  // history: true,
  // hashbang: false,
  // // root: "/your app directory",
  // base: "",
});

export default router;
